import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Capture affiliate ref code before React renders (guaranteed early)
(function() {
  const ref = new URLSearchParams(window.location.search).get("ref");
  if (ref) {
    localStorage.setItem("_ref", ref);
    const url = new URL(window.location.href);
    url.searchParams.delete("ref");
    window.history.replaceState({}, "", url.toString());
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
